import { render, staticRenderFns } from "./CardAddElementAction.vue?vue&type=template&id=1a1458d5"
import script from "./CardAddElementAction.vue?vue&type=script&lang=js"
export * from "./CardAddElementAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports